// Minimal CSV export for the Calendar/Count tabs (date+count rows), which
// have no SVG to rasterize so the full ExportMenu (PNG + CSV) doesn't apply
// (D-IR-10). Intensity tab keeps using the existing ExportMenu/ChartSeries CSV.

function escapeCsvCell(cell: string): string {
  return /[",\n]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell;
}

export function downloadCsv(header: string[], rows: (string | number)[][], filename: string): void {
  const csv = [header, ...rows]
    .map((r) => r.map((c) => escapeCsvCell(String(c))).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
